import * as yup from 'yup';
import {
  INFORMATION_REQUESTED,
  NOTIFICATION_RECEIVED,
  FIRST_CHARGEBACK,
  DEFENSE_DECLINED,
  DEFENSE_ACCEPTED,
  WON,
  LOST,
  CHARGE_REFUNDED,
  UNDER_REVIEW,
  NEEDS_RESPONSE,
  CLOSED,
} from './helpers';
import {
  multiSelectValidation,
  amountSchema,
} from 'components/PaymentFilter/defaultFilters.schema';

export const FIELD_NAMES = {
  statusCheckbox: 'statusCheckbox',
  amountCheckbox: 'amountCheckbox',

  [INFORMATION_REQUESTED]: INFORMATION_REQUESTED,
  [NOTIFICATION_RECEIVED]: NOTIFICATION_RECEIVED,
  [FIRST_CHARGEBACK]: FIRST_CHARGEBACK,
  [DEFENSE_DECLINED]: DEFENSE_DECLINED,
  [DEFENSE_ACCEPTED]: DEFENSE_ACCEPTED,
  [WON]: WON,
  [LOST]: LOST,
  [CHARGE_REFUNDED]: CHARGE_REFUNDED,
  [UNDER_REVIEW]: UNDER_REVIEW,
  [NEEDS_RESPONSE]: NEEDS_RESPONSE,
  [CLOSED]: CLOSED,

  amount_filter: 'amount_filter',
  amount: 'amount',
};
export const defaultValues = (currentFilters) => {
  const statusFilters = currentFilters.status
    ? new Set(currentFilters.status.split(','))
    : new Set();
  const defaultStatus = (fieldName) =>
    statusFilters.has(fieldName) ? true : false;

  return {
    [FIELD_NAMES.statusCheckbox]: currentFilters.statusCheckbox,
    status: {
      [INFORMATION_REQUESTED]: defaultStatus(INFORMATION_REQUESTED),
      [NOTIFICATION_RECEIVED]: defaultStatus(NOTIFICATION_RECEIVED),
      [FIRST_CHARGEBACK]: defaultStatus(FIRST_CHARGEBACK),
      [DEFENSE_DECLINED]: defaultStatus(DEFENSE_DECLINED),
      [DEFENSE_ACCEPTED]: defaultStatus(DEFENSE_ACCEPTED),
      [WON]: defaultStatus(WON),
      [LOST]: defaultStatus(LOST),
      [CHARGE_REFUNDED]: defaultStatus(CHARGE_REFUNDED),
      [UNDER_REVIEW]: defaultStatus(UNDER_REVIEW),
      [NEEDS_RESPONSE]: defaultStatus(NEEDS_RESPONSE),
      [CLOSED]: defaultStatus(CLOSED),
    },
    [FIELD_NAMES.amountCheckbox]: !!currentFilters.amount,
    [FIELD_NAMES.amount_filter]: currentFilters.amount_filter,
    [FIELD_NAMES.amount]: currentFilters.amount,
  };
};

const statusValidation = multiSelectValidation(FIELD_NAMES.statusCheckbox);

const schema = yup.object().shape({
  [INFORMATION_REQUESTED]: statusValidation,
  [NOTIFICATION_RECEIVED]: statusValidation,
  [FIRST_CHARGEBACK]: statusValidation,
  [DEFENSE_DECLINED]: statusValidation,
  [DEFENSE_ACCEPTED]: statusValidation,
  [WON]: statusValidation,
  [LOST]: statusValidation,
  [CHARGE_REFUNDED]: statusValidation,
  [UNDER_REVIEW]: statusValidation,
  [NEEDS_RESPONSE]: statusValidation,
  [CLOSED]: statusValidation,

  ...amountSchema,
});

export default schema;
